var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0016 29.3336V17.3336M16.0016 29.3336L12.6682 26.6669M16.0016 29.3336L19.3349 26.6669M6.71358 12.1562C5.45252 12.4736 4.35075 13.2405 3.61525 14.3128C2.87975 15.3852 2.56115 16.6893 2.71932 17.98C2.87749 19.2707 3.50153 20.4592 4.4742 21.3223C5.44687 22.1853 6.70122 22.6635 8.00158 22.6669H9.33491",
    stroke: "#7F8591",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1075 9.51435C20.6518 7.70978 19.527 6.14601 17.961 5.14003C16.3951 4.13405 14.5052 3.76114 12.6745 4.09689C10.8438 4.43264 9.20931 5.45193 8.10228 6.94814C6.99525 8.44434 6.49854 10.3055 6.71286 12.1544C6.71286 12.1544 6.91686 13.3304 7.3342 13.997",
    stroke: "#7F8591",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6693 22.6615C23.6107 22.6608 24.5412 22.4608 25.3998 22.0746C26.2583 21.6884 27.0253 21.1247 27.6502 20.4208C28.2752 19.7168 28.744 18.8884 29.0258 17.9902C29.3075 17.0919 29.3959 16.1442 29.285 15.2094C29.1741 14.2746 28.8664 13.3738 28.3823 12.5664C27.8982 11.7591 27.2486 11.0634 26.4763 10.5252C25.7039 9.98695 24.8263 9.61841 23.9013 9.44381C22.9762 9.2692 22.0247 9.29248 21.1093 9.51212L19.3359 9.99479",
    stroke: "#7F8591",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/CloudIcon.2a5f6cdca6a7da4e816644ea36653f45.svg";
export { ForwardRef as ReactComponent };